module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg5NiA1NDRhMzIgMzIgMCAwIDEgMzIgMzJ2Mjg4YTMyIDMyIDAgMCAxLTMyIDMySDEyOGEzMiAzMiAwIDAgMS0zMi0zMnYtMjg4YTMyIDMyIDAgMCAxIDMyLTMyaDc2OHogbTAtNDE2YTMyIDMyIDAgMCAxIDMyIDMydjI4OGEzMiAzMiAwIDAgMS0zMiAzMkgxMjhhMzIgMzIgMCAwIDEtMzItMzJWMTYwYTMyIDMyIDAgMCAxIDMyLTMyaDc2OHoiIGZpbGw9IiMwIiBwLWlkPSIzMjI3Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/View agenda-filled.svg
// module id = zrtZ
// module chunks = 74